import { Container, Content, FooterSection, FooterLinks, FooterLink, SocialLinks, Copyright } from './styles'
import { FaLinkedin, FaEnvelope } from 'react-icons/fa'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <Container>
      <Content>
        <FooterSection>
          <h3>Calculadoras de Engenharia</h3>
          <p>
            Ferramentas gratuitas e precisas para simplificar seus cálculos de engenharia. Desenvolvido com dedicação
            para engenheiros e estudantes.
          </p>
          <SocialLinks>
            <a href="mailto:mourajrn@gmail.com" aria-label="Email">
              <FaEnvelope />
            </a>
            <a
              href="https://www.linkedin.com/in/mourajrn/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h4>Estruturas</h4>
          <FooterLinks>
            <FooterLink to="/concreto">Concreto</FooterLink>
            <FooterLink to="/aco">Aço</FooterLink>
            <FooterLink to="/alvenaria">Alvenaria</FooterLink>
          </FooterLinks>
        </FooterSection>

        <FooterSection>
          <h4>Outras Áreas</h4>
          <FooterLinks>
            <FooterLink to="/eletrica">Elétrica</FooterLink>
            <FooterLink to="/hidrossanitario">Hidrossanitário</FooterLink>
            <FooterLink to="/geotecnia/estaca">Geotecnia</FooterLink>
          </FooterLinks>
        </FooterSection>

        <FooterSection>
          <h4>Populares</h4>
          <FooterLinks>
            <FooterLink to="/concreto/flexao">Flexão</FooterLink>
            <FooterLink to="/concreto/cisalhamento">Cisalhamento</FooterLink>
            <FooterLink to="/eletrica/circuitos">Circuitos</FooterLink>
          </FooterLinks>
        </FooterSection>
      </Content>

      <Copyright>
        <div className="copyright-content">
          <p>© {currentYear} Calculadoras de Engenharia. Todos os direitos reservados.</p>
          <p className="made-with">
            Feito com <span className="heart">❤️</span> para engenheiros
          </p>
        </div>
      </Copyright>
    </Container>
  )
}
